export interface CollaborationSession {
  id: string;
  projectId: string;
  name: string;
  description?: string;
  scheduledFor?: Date;
  scheduledDate?: Date;
  duration: number;
  status: string;
  participants?: any[];
  files?: any[];
  hostId?: string;
  recordingUrl?: string;
}

// Mock data for sessions
export const mockCollaborationSessions = [
  {
    id: "1",
    projectId: "1",
    name: "Vocal Recording Session",
    description: "Recording vocals for 'Summer Nights' track",
    scheduledDate: new Date("2024-03-15T14:00:00"),
    scheduledFor: new Date("2024-03-15T14:00:00"),
    duration: 120,
    status: "Scheduled",
    hostId: "u1",
    participants: [
      {
        id: "u1",
        name: "Jamie Collins",
        role: "Producer"
      },
      {
        id: "u2",
        name: "Alex Turner",
        role: "Vocalist"
      },
      {
        id: "u3",
        name: "Sam Wilson",
        role: "Guitarist"
      },
      {
        id: "u4",
        name: "Taylor Swift",
        role: "Engineer"
      }
    ],
    files: [
      {
        id: "f1",
        name: "Vocal_Take_1.wav",
        type: "audio/wav",
        uploadedBy: "Alex Turner",
        uploadedAt: new Date("2024-03-15T14:30:00")
      },
      {
        id: "f2",
        name: "Bass_Track.wav",
        type: "audio/wav",
        uploadedBy: "Jamie Collins",
        uploadedAt: new Date("2024-03-15T15:15:00")
      }
    ]
  },
  {
    id: "2",
    projectId: "1",
    name: "Mixing Session",
    description: "Mixing the recorded tracks",
    scheduledDate: new Date("2024-03-20T10:00:00"),
    scheduledFor: new Date("2024-03-20T10:00:00"),
    duration: 180,
    status: "Scheduled",
    hostId: "u1",
    participants: [
      {
        id: "u1",
        name: "Jamie Collins",
        role: "Producer"
      },
      {
        id: "u4",
        name: "Taylor Swift",
        role: "Engineer"
      }
    ],
    files: []
  }
];
